<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RegisterEntry"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.register.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcRegisterEntryHeader
      :register="resource.register || registerObj"
      :entry="resource"
      :selectRegister="selectRegister"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
      @registerChanged="evh_8564662037462133_registerChanged($event, {})"
    >
    </UcRegisterEntryHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      :readonly="resource.isReadOnly"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetRegisterEntry
        :item="editor"
        :form="forms[formName]"
        @documentTypeChanged="evh_5534025912102772_documentTypeChanged($event, {})"
        @reload="evh_5534025912102772_reload($event, {})"
        @close="evh_5534025912102772_close($event, {})"
        @changed="evh_5534025912102772_changed($event, {})"
      >
      </FieldsetRegisterEntry>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.register.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Create another entry'|pgettext('RegisterEntry|Command')"
      :disabled="!forms[formName] || !forms[formName].submittable || actions.save.isRunning"
      variant="light"
      iconAppend="mdi:forward"
      v-if="!resource.isNew"
      @click="evh_1548630417156826_click($event, {})"
    >
    </ItpButton>
    <ItpBox
      class="ml-auto"
    >
      <ItpButton
        :form="forms[formName]"
        :text="'Create entry'|pgettext('RegisterEntry/Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="resource.isNew"
      >
      </ItpButton>
      <ItpButton
        :form="formId"
        :text="'Save changes'|pgettext('Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="!resource.isNew && !resource.isReadOnly && forms[formName]"
      >
      </ItpButton>
      <ItpButton
        :text="'Close'|gettext"
        variant="default"
        @click.prevent.stop="evh_1589624209624921_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class RegisterEntry extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getContainer(...args: any[]) {
    const [editor] = args;

    return {
      self: this.$fn.urlFor('create_register_entry', {
        register_id: editor.version.register_id,
        version_id: editor.version.version_id,
      }),
      object: 'list',
      data: []
    }
  }

  getPayload(...args: any[]) {
    const [editor] = args;
    const exclude = editor.document_type === 'invoice'
      ? ['contract', 'version']
      : (editor.document_type === 'contract' ? ['invoice', 'version'] : ['contract', 'invoice', 'version'])

    const result = editor.isNew ?
      editor.getData({ exclude }) :
      editor.getChanges({ exclude, skipEmbeddedLists: true })

    if (result.invoice && !result.invoice.invoice_number) {
      result.invoice = null;
    }

    if (result.contract && !result.contract.contract_number) {
      result.contract = null;
    }

    return result
  }

  onDocumentTypeChanged(...args: any[]) {
    const [editor] = args;
    const docType = editor.document_type

    if (editor.isNew) {
      return this.reloadTemplate(editor);
    }

    if (docType == 'invoice' && !editor.invoice) {
      editor.invoice = { id: null, invoice_number: null }
      return;
    }

    if (docType == 'contract' && !editor.contract) {
      editor.contract == { id: null, contract_number: null }
      return;
    }

    editor.invoice = null;
    editor.contract = null;
  }

  reloadTemplate(...args: any[]) {
    const [editor] = args;

    return this.$fn
      .fetch('get_register_entry_template', {
        parameters: {
          entry_id: editor.id,
          register_id: editor.version.register_id,
          version_id: editor.version.version_id,
          direction: editor.direction,
          document_type: editor.document_type,
          invoice_id: editor.invoice?.id,
          contract_id: editor.contract?.id
        },
        asResource: true
      })
      .then(resource => {
        this.setData('resource', resource);
        this.setData('editor', resource.editor());
      })
  }

  createNew(...args: any[]) {
    const editor = this.editor;
    const resource = this.resource;

    return this.$fn
      .fetch('get_register_entry_template', {
        parameters: {
          register_id: resource.version.register_id,
          version_id: resource.version.version_id,
          direction: resource.direction,
          document_type: resource.document_type,
        },
        asResource: true
      })
      .then(resource => {
        this.setData('resource', resource);
        this.setData('editor', resource.editor());
      })
  }

  onRegisterChanged(...args: any[]) {
    const [value] = args;
    this.editor.version.register_id = value.selectedRegisterId
    this.editor.version.version_id = value.selectedVersionId
    this.reloadTemplate(this.editor)
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
  })
  registerId!: string;

  @Watch('registerId')
  onRegister_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("registerId")
  }

  @Prop({
    type: String,
  })
  versionId!: string;

  @Watch('versionId')
  onVersion_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("versionId")
  }

  @Prop({
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  createTitle!: any;
  defaultTitle!: any;
  registerObj!: any;

  async $$load_registerObj() {
    return this.register
  }

  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('read_register_entry', { parameters: { id: this.oid }, asResource: true })
      : this.$fn.fetch('get_register_entry_template', {
        parameters: {
          register_id: this.registerId,
          version_id: this.versionId,
          invoice_id: this.invoice ? this.invoice.id : null
        }, asResource: true
      })
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  selectRegister!: any;

  async $$load_selectRegister() {
    return this.resource && this.resource.isNew && this.invoice && !this.registerId && !this.versionId
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'createTitle', 'defaultTitle', 'registerObj', 'resource', 'editor', 'selectRegister', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "registerEntry",
        createTitle: this.$fn.pgettext("RegisterEntry", "New Registry Entry"),
        defaultTitle: this.$fn.pgettext("RegisterEntry", "Edit Entry"),
        registerObj: null,
        resource: null,
        editor: null,
        selectRegister: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get isDeletable() {
    if (this.loaded) {

      return this.oid != null
    }
    return null;
  }

  get creatingTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("RegisterEntry", "Create new entry")
    }
    return null;
  }

  get editingTitle() {
    if (this.loaded) {

      return '#' + this.resource.entry_number
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.resource.isNew ? this.creatingTitle : this.editingTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4432_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4432, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_4440_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_4440, alias=undefined
    return {
      grid: "register",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_script_4442_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8564662037462133_script_4442, alias=undefined
    this.onRegisterChanged($event.data)
  }

  async act_8564662037462133_script_4442_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8564662037462133_script_4442, alias=undefined
    return {
      value: () => this.act_8564662037462133_script_4442_getActionArgs_value($event),
    }
  }

  async evh_8564662037462133_registerChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_registerChanged.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_emit_4446_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_4446, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async act_1040167445267876_reloadSlickgrid_4448_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_4448, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_1040167445267876_setData_4450_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_4450, alias=undefined
    return {
      path: "selectRegister",
      value: false,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_rest_4444_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_4444, alias=save
    return {
      method: "save",
      container: this.getContainer(this.editor),
      resource: this.editor,
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_script_4452_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5534025912102772_script_4452, alias=undefined
    this.onDocumentTypeChanged(this.editor)
  }

  async act_5534025912102772_script_4452_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5534025912102772_script_4452, alias=undefined
    return {
      value: () => this.act_5534025912102772_script_4452_getActionArgs_value($event),
    }
  }

  async evh_5534025912102772_documentTypeChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_documentTypeChanged.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_emit_4458_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5534025912102772_emit_4458, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async evh_5534025912102772_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_script_4460_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1548630417156826_script_4460, alias=undefined
    this.createNew()
  }

  async act_1548630417156826_script_4460_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1548630417156826_script_4460, alias=undefined
    return {
      value: () => this.act_1548630417156826_script_4460_getActionArgs_value($event),
    }
  }

  async evh_1548630417156826_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_click.executeFromDOM(this, event, scope);
  }

  async evh_1589624209624921_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1589624209624921_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4432: actions.CloseModalAction;
    evh_7315092382398562_close_4431: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_4434: actions.CloseComponentAction;
    evh_2248226175642056_close_4433: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_4436: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_4435: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeComponent_4438: actions.CloseComponentAction;
    evh_8564662037462133_deleted_4437: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_4440: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_4439: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_8564662037462133_script_4442: actions.ScriptAction;
    evh_8564662037462133_registerChanged_4441: actions.EventHandlerImpl;
    evh_8564662037462133_registerChanged: actions.EventHandlerGroup;
    act_1040167445267876_emit_4446: actions.EmitAction;
    evh_1040167445267876_saved_4445: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_4448: actions.ReloadSlickgridAction;
    evh_1040167445267876_saved_4447: actions.EventHandlerImpl;
    act_1040167445267876_setData_4450: actions.SetDataAction;
    evh_1040167445267876_saved_4449: actions.EventHandlerImpl;
    act_1040167445267876_rest_4444: actions.RestAction;
    evh_1040167445267876_submit_4443: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_script_4452: actions.ScriptAction;
    evh_5534025912102772_documentTypeChanged_4451: actions.EventHandlerImpl;
    evh_5534025912102772_documentTypeChanged: actions.EventHandlerGroup;
    act_5534025912102772_reloadComponentData_4454: actions.ReloadComponentDataAction;
    evh_5534025912102772_reload_4453: actions.EventHandlerImpl;
    evh_5534025912102772_reload: actions.EventHandlerGroup;
    act_5534025912102772_closeComponent_4456: actions.CloseComponentAction;
    evh_5534025912102772_close_4455: actions.EventHandlerImpl;
    evh_5534025912102772_close: actions.EventHandlerGroup;
    act_5534025912102772_emit_4458: actions.EmitAction;
    evh_5534025912102772_changed_4457: actions.EventHandlerImpl;
    evh_5534025912102772_changed: actions.EventHandlerGroup;
    act_1548630417156826_script_4460: actions.ScriptAction;
    evh_1548630417156826_click_4459: actions.EventHandlerImpl;
    evh_1548630417156826_click: actions.EventHandlerGroup;
    act_1589624209624921_closeComponent_4462: actions.CloseComponentAction;
    evh_1589624209624921_clickPreventStop_4461: actions.EventHandlerImpl;
    evh_1589624209624921_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4432 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4432_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4431 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4432,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4431],
      }
    );
    const act_2248226175642056_closeComponent_4434 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4433 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_4434,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4433],
      }
    );
    const act_8564662037462133_reloadComponentData_4436 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_4435 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_4436,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_4435],
      }
    );
    const act_8564662037462133_closeComponent_4438 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_4437 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeComponent_4438,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_8564662037462133_reloadSlickgrid_4440 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_4440_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_4439 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_4440,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_4437, evh_8564662037462133_deleted_4439],
      }
    );
    const act_8564662037462133_script_4442 = new actions.ScriptAction(
      {
        actionArgs: this.act_8564662037462133_script_4442_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_registerChanged_4441 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_script_4442,
        event: "registerChanged",
        displayName: "script",
      }
    );
    const evh_8564662037462133_registerChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_registerChanged_4441],
      }
    );
    const act_1040167445267876_emit_4446 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_4446_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4445 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_4446,
        event: "saved",
        displayName: "emit",
      }
    );
    const act_1040167445267876_reloadSlickgrid_4448 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_4448_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4447 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_4448,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_setData_4450 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_4450_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4449 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_4450,
        event: "saved",
        displayName: "setData",
      }
    );
    const act_1040167445267876_rest_4444 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_4444_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_saved_4445, evh_1040167445267876_saved_4447, evh_1040167445267876_saved_4449],
      }
    );
    const evh_1040167445267876_submit_4443 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_4444,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4443],
      }
    );
    const act_5534025912102772_script_4452 = new actions.ScriptAction(
      {
        actionArgs: this.act_5534025912102772_script_4452_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_documentTypeChanged_4451 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_script_4452,
        event: "documentTypeChanged",
        displayName: "script",
      }
    );
    const evh_5534025912102772_documentTypeChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_documentTypeChanged_4451],
      }
    );
    const act_5534025912102772_reloadComponentData_4454 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_reload_4453 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadComponentData_4454,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5534025912102772_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_reload_4453],
      }
    );
    const act_5534025912102772_closeComponent_4456 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_close_4455 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_closeComponent_4456,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_5534025912102772_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_close_4455],
      }
    );
    const act_5534025912102772_emit_4458 = new actions.EmitAction(
      {
        actionArgs: this.act_5534025912102772_emit_4458_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_changed_4457 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_emit_4458,
        event: "changed",
        displayName: "emit",
      }
    );
    const evh_5534025912102772_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_changed_4457],
      }
    );
    const act_1548630417156826_script_4460 = new actions.ScriptAction(
      {
        actionArgs: this.act_1548630417156826_script_4460_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_click_4459 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_script_4460,
        event: "click",
        displayName: "script",
      }
    );
    const evh_1548630417156826_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_click_4459],
      }
    );
    const act_1589624209624921_closeComponent_4462 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1589624209624921_clickPreventStop_4461 = new actions.EventHandlerImpl(
      {
        action: act_1589624209624921_closeComponent_4462,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1589624209624921_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1589624209624921_clickPreventStop_4461],
      }
    );
    return {
      act_7315092382398562_closeModal_4432,
      evh_7315092382398562_close_4431,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_4434,
      evh_2248226175642056_close_4433,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_4436,
      evh_8564662037462133_reload_4435,
      evh_8564662037462133_reload,
      act_8564662037462133_closeComponent_4438,
      evh_8564662037462133_deleted_4437,
      act_8564662037462133_reloadSlickgrid_4440,
      evh_8564662037462133_deleted_4439,
      evh_8564662037462133_deleted,
      act_8564662037462133_script_4442,
      evh_8564662037462133_registerChanged_4441,
      evh_8564662037462133_registerChanged,
      act_1040167445267876_emit_4446,
      evh_1040167445267876_saved_4445,
      act_1040167445267876_reloadSlickgrid_4448,
      evh_1040167445267876_saved_4447,
      act_1040167445267876_setData_4450,
      evh_1040167445267876_saved_4449,
      act_1040167445267876_rest_4444,
      evh_1040167445267876_submit_4443,
      evh_1040167445267876_submit,
      act_5534025912102772_script_4452,
      evh_5534025912102772_documentTypeChanged_4451,
      evh_5534025912102772_documentTypeChanged,
      act_5534025912102772_reloadComponentData_4454,
      evh_5534025912102772_reload_4453,
      evh_5534025912102772_reload,
      act_5534025912102772_closeComponent_4456,
      evh_5534025912102772_close_4455,
      evh_5534025912102772_close,
      act_5534025912102772_emit_4458,
      evh_5534025912102772_changed_4457,
      evh_5534025912102772_changed,
      act_1548630417156826_script_4460,
      evh_1548630417156826_click_4459,
      evh_1548630417156826_click,
      act_1589624209624921_closeComponent_4462,
      evh_1589624209624921_clickPreventStop_4461,
      evh_1589624209624921_clickPreventStop,
      save: act_1040167445267876_rest_4444,
    }
  }
}

Vue.component("RegisterEntry", RegisterEntry);

</script>